var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCasino43A0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4787",
    "data-name": "Group 4787",
    transform: "translate(-178 -759)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4364",
    "data-name": "Rectangle 4364",
    width: 24,
    height: 24,
    transform: "translate(178 759)",
    fill: "none",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4767",
    "data-name": "Group 4767",
    transform: "translate(182.092 760.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4769",
    "data-name": "Group 4769",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6696",
    "data-name": "Path 6696",
    d: "M14.336,8.783A6.063,6.063,0,0,1,10.476,7.3,5.272,5.272,0,0,1,9.208,4.957c0-.4.023-.815.057-1.245A.385.385,0,0,0,9.254,3.6a1.128,1.128,0,0,0-.238.226,9.983,9.983,0,0,0-.94,1.007A17.669,17.669,0,0,0,5.427,9.678,4.984,4.984,0,0,0,4.6,9.61c-.113,0-.238,0-.351.011C6.107,4.606,8.371,2.07,12.706.055a.554.554,0,0,1,.747.272.571.571,0,0,1-.272.758A15.326,15.326,0,0,0,9.4,3.463a5.879,5.879,0,0,1,3.453,1.46,6.156,6.156,0,0,1,1.483,3.86",
    transform: "translate(0.561 0)",
    fill: "rgba(247,144,78,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6697",
    "data-name": "Path 6697",
    d: "M14.558,14.058a4.15,4.15,0,0,1-4.019,3.973h-.068a3.984,3.984,0,0,1-2.162-.623,5.141,5.141,0,0,0-.43-6.622,3.778,3.778,0,0,1,1.223-.7A8.93,8.93,0,0,1,7.63,4.413a9.983,9.983,0,0,1,.94-1.007,1.128,1.128,0,0,1,.238-.226.385.385,0,0,1,.011.113c-.034.43-.057.849-.057,1.245-.011,2.456.521,4.211,1.63,5.309h.079a4.015,4.015,0,0,1,2.921,1.245,4.062,4.062,0,0,1,1.166,2.966",
    transform: "translate(1.007 0.419)",
    fill: "rgba(247,144,78,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6698",
    "data-name": "Path 6698",
    d: "M10.324,13.651a5.177,5.177,0,0,1-1.007,3.056.011.011,0,0,0-.011.011,5.121,5.121,0,0,1-4.143,2.094A5.162,5.162,0,0,1,4.811,8.5c.113-.011.238-.011.351-.011a4.984,4.984,0,0,1,.826.068,5.168,5.168,0,0,1,2.887,1.517l.011.011a5.173,5.173,0,0,1,1.438,3.566",
    transform: "translate(0 1.12)",
    fill: "#f7904e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasino43A0);
export default __webpack_public_path__ + "static/media/casino43a0.73ce99d042d8740383c538202c4c07b7.svg";
export { ForwardRef as ReactComponent };